<script>
export default {
  computed: {
    selection() {
      return this.$store.getters['userSelections/getFitPreference'](this.type);
    },
  },

  mounted() {
    if (!this.selection) {
      this.setSelection(this.default);
    }
  },

  methods: {
    setSelection(value) {
      this.$store.commit('userSelections/setFitPreference', {type: this.type, value});
    },
  },
};
</script>
